import { MENU_DATA } from "@/components/Layout/Header";
import { useRouter } from "next/router";

import { useMemo } from "react";

export function useActivePathCheck() {
  const router = useRouter();

  const activePath = useMemo(() => {
    const path = router.asPath;
    const pathname = router.pathname;

    if (path === "/") return "홈";

    if (path.startsWith(MENU_DATA["견적"].to)) {
      return MENU_DATA["견적"].activePath;
    }

    if (path.startsWith(MENU_DATA["가이드북"].to)) {
      return MENU_DATA["가이드북"].activePath;
    }

    if (pathname === MENU_DATA["상품안내"].to) {
      return MENU_DATA["상품안내"].activePath;
    }

    if (path.startsWith(MENU_DATA["후기"].to)) {
      return MENU_DATA["후기"].activePath;
    }

    return "";
  }, [router.asPath, router.pathname]);

  return { activePath };
}
